module.exports = __webpack_public_path__ + "img/5.4f48b158.jpg";